import {Component, OnInit, Input, Output, EventEmitter, AfterViewInit} from '@angular/core';
import { ABMRolesService } from '../../../../services';
import { Observable } from 'rxjs/Observable';
import { FormControl } from '@angular/forms';
import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';

@Component({
  selector: 'app-roles-autocomplete',
  templateUrl: './roles-autocomplete.component.html',
  styleUrls: ['./roles-autocomplete.component.scss']
})
export class RolesAutocompleteComponent implements OnInit, AfterViewInit {

  @Input('placeholder') placeholder = 'Filtrar por roles';

  // Roles
  private roles = [];
  public rolesStateControl: FormControl;
  public filteredRoles = [];
  public selectedRoles = [];

  private _selection = [];

  @Input()
  set selection(selection) {
    this._selection = selection;
  }

  @Input() disabled: boolean;
  @Output() returnChangesEvent = new EventEmitter<{Id: any, Action: string}>();
  @Output() ViewInitialized = new EventEmitter<{}>();

  @Input() showIcon = true;

  constructor(private abmRolesService: ABMRolesService) {}

  ngOnInit() {
    this.abmRolesService.getRoles()
      .subscribe( data => {
        this.roles = data;
        if (this._selection) {
          this.selectedRoles = this.roles.filter(r => this._selection.indexOf(r.Id)>=0);
        }
      });

    this.rolesStateControl = new FormControl();
    this.rolesStateControl.valueChanges
      .startWith(null)
      .debounceTime(500)
      .subscribe(value => {
        if (value && value.length >= 2) {
          let re = new RegExp(value,'i');
          this.filteredRoles = this.roles.filter(r => r.RolName.search(re)>=0);
          // filtramos los valores ya seleccionados
          this.filterSelectedResults();
        } else {
          this.filteredRoles = [];
        }
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.ViewInitialized.emit();
    });
  }

  selectRole(event: MdOptionSelectionChange, value) {
    if (event.source.selected &&
      this.selectedRoles.findIndex(v => v.Id === value.Id) < 0)
    {
      this.selectedRoles.push(value);
      // en comunicaciones los cambios deben reflejarse, emitir evento
      this.returnChangesEvent.emit({Id: value.Id, Action: 'add'});
    }
  }

  removeRole(role) {
    // en comunicaciones los cambios deben reflejarse, emitir evento
    this.selectedRoles = this.selectedRoles.filter(r => r.Id !== role.Id);
    this.filterSelectedResults();
    this.returnChangesEvent.emit({Id: role.Id, Action: 'remove'});
  }

  displayFn(value){
    return null;
  }

  public deleteRolFromParent(id) {
    // si se requiere eliminar un rol desde el objeto padre se usa esta funcion
    this.selectedRoles = this.selectedRoles.filter(r => r.Id !== id);
  }

  filterSelectedResults() {
    this.filteredRoles = this.selectedRoles.length > 0 ? this.filteredRoles.filter(x => this.selectedRoles.findIndex(y => y.Id === x.Id) < 0 ) : this.filteredRoles;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/roles-autocomplete/roles-autocomplete.component.ts